import * as React from 'react';
import {Link} from 'react-router-dom';
import s from './goDirectToLastPage.scss';
import {withTranslation} from 'react-i18next';
type DirectToLastPageLinkProps = {
  active: boolean,
  hide: boolean,
  path: string,
  t: (...args: any[]) => any,
  page: number
};
class DirectToLastPageLink extends React.Component<DirectToLastPageLinkProps, {}> {
  render() {
    const {active, hide, path, page, t} = this.props;
    return (
      <li
        data-hooks="go-direct-to-last-page"
        data-disabled={active}
        data-hide={hide}
        className={s.link}
      >
        <Link to={path}>
          {page}
          <span className={s.hidden}>{`${t('navigate-to-page')} ${page}`}</span>
        </Link>
      </li>
    );
  }
}
export default withTranslation()(DirectToLastPageLink);
